import React, { useState } from 'react';
import './Modal.scss';
import Loader  from '../Loader/Loader';
import CustomButton from '../ui/Button/Button';
import { storeNameList } from '../../Container/utils';
const Modal = ({
  isOpen,
  onClose,
  type,
  data,
  filterStores,
  filterEmployees,
  target,
  onLoadedData,
  currentFilteritmes,
  manualData = [],
  userdata = [],
  loader,
}) => {
  const [totalEmployee, setTotalEmployee] = useState([]);
  // const [totalStores, setTotalStores] = useState([]);
  const [currentStoreSelected, setCurrentStoreSelected] = useState('');
  const [currentEmpSelected, setCurrentEmpSelected] = useState('');
  const [clickedButton, setClickedButton] = useState(null);
  const [clickedButtonEmp, setClickedButtonEmp] = useState(null);

  const handleStore = (store) => {
    if (store !== clickedButton) {
      setClickedButton(store);
      setClickedButtonEmp('');
      setCurrentEmpSelected('');
      setCurrentStoreSelected(store);
    }
    const employeesSet = new Set();

    data?.forEach((emp) => {
      if (emp.storeInvoice === store && emp.user !== 'admin@vyadom.com') {
        employeesSet.add(emp.user);
      }
    });

    const sortedEmployees = Array.from(employeesSet).sort((a, b) => a.localeCompare(b));
    setTotalEmployee(sortedEmployees);
  };

  const handleEmployee = (emp) => {
    setClickedButtonEmp((prev) => (emp !== prev ? emp : ''));
    setCurrentEmpSelected((prev) => (emp !== prev ? emp : ''));    
  };

  const handleReps = (rep) => {
    setClickedButtonEmp(rep);
    setCurrentEmpSelected(rep);
    const storeSet = new Set();
    data?.forEach((emp) => {
      if (emp.user === rep) {
        storeSet.add(emp.storeInvoice);
      }
    });
    // const sortedStores = Array.from(storeSet).sort((a, b) => a.localeCompare(b));
    // setTotalStores(sortedStores);
  };

  // const handleRepsStore = (store) => {
  //   setClickedButton((prev) => (store !== prev ? store : ''));
  //   setCurrentStoreSelected((prev) => (store !== prev ? store : ''));
  // };

  const handleSubmit = (event) => {
    event.preventDefault();

    const cisEmployeesList = [];
    const targetList = [];
    const accandApple = [];
    const filterData = (list, storeKey, empKey, storeValue, empValue) => {
      list?.forEach((item) => {
        if (
          (storeValue === '' || item[storeKey] === storeValue) &&
          (empValue === '' || item[empKey] === empValue)
        ) {
          if (list === data) cisEmployeesList.push(item);
          else if (list === target) targetList.push(item);
          else if (list === manualData) accandApple.push(item);
        }
      });
    };

    filterData(data, 'storeInvoice', 'user', currentStoreSelected, currentEmpSelected);
    filterData(target, 'storeinvoice', 'username', currentStoreSelected, currentEmpSelected);
    filterData(manualData, 'storeid', 'employee', currentStoreSelected, currentEmpSelected);

    onLoadedData([cisEmployeesList, targetList, accandApple]);
    setTotalEmployee([]);
    // setTotalStores([]);
    setCurrentEmpSelected('');
    setCurrentStoreSelected('');
    setClickedButton('');
    setClickedButtonEmp('');
    currentFilteritmes([
      currentEmpSelected.slice(0, -11),
      storeNameList[currentStoreSelected.trim()],
    ]);
    onClose();
  };


  const capitalizeFirstLetter = (string) => {
    let user = [];
    for (let key in userdata) {
      if (userdata[key].username === string) {
        user.push(userdata[key].fullname);
      }
    }
    return user.length > 0
      ? user[0]
      : string.charAt(0).toUpperCase() + string.slice(1).toLowerCase().slice(0, -11);
  };

  const handleModalClose = () => {
    setCurrentEmpSelected('');
    setCurrentStoreSelected('');
    setClickedButton('');
    setClickedButtonEmp('');
    setTotalEmployee([]);
    // setTotalStores([]);
    onClose();
  };
  return (
    isOpen && (
      <div className="main-modal-overlay" /* id='myModal' */ /* onClick={handleOutsideClick} */>
        <div className="main-modal">
          <div className="main-modal-header">
            <h2>Filter: {type}</h2>
            <div className="main-close-btn">
              <button onClick={handleModalClose}>&times;</button>
            </div>
          </div>
          {loader ? (
            <Loader />
          ) : (
            <>
              <div className={`main-modal-content ${type === "Reps"? "center" : ""}`}  >
                {type === 'Stores' ? (
                  <>
                    <div className="store-data">
                      {filterStores?.map((store) => (
                        <div className="button" key={store}>
                          <button
                            onClick={() => handleStore(store)}
                            className={clickedButton === store ? 'clicked' : ''}
                          >
                            {storeNameList[store.trim()]}
                          </button>
                        </div>
                      ))}
                    </div>
                    <div className="rep-data">
                      {totalEmployee?.map((emp) => (
                        <div className="button" key={emp}>
                          <button
                            onClick={() => handleEmployee(emp)}
                            className={clickedButtonEmp === emp ? 'clicked' : ''}
                          >
                            {capitalizeFirstLetter(emp)}
                          </button>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="rep-data only-reps">
                      {filterEmployees?.map((emp) => (
                        <div className="button" key={emp}>
                          <button
                            onClick={() => handleReps(emp)}
                            className={clickedButtonEmp === emp ? 'clicked' : ''}
                          >
                            {capitalizeFirstLetter(emp)}
                          </button>
                        </div>
                      ))}
                    </div>
                    {/* <div className="store-data"> */}
                      {/* {totalStores?.map((store) => (
                        <div className="button" key={store}>
                          <button
                            onClick={() => handleRepsStore(store)}
                            className={clickedButton === store ? 'clicked' : ''}
                          >
                            {storeNameList[store.trim()]}
                          </button>
                        </div>
                      ))} */}
                    {/* </div> */}
                  </>
                )}
              </div>
              <div className="submit-btn">
                <CustomButton
                  btnLabel="Submit"
                  onClick={handleSubmit}
                />
              </div>
            </>
          )}
        </div>
      </div>
    )
  );
};

export default Modal;
